module.exports = __webpack_public_path__ + "static/media/sf_1400.8dfcef4eac6552d2709dd487cbf15223.png";